// JS CLASS

export default class FooterClass {
	constructor() {

	}

  init() {
  }
}
